module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/setting/setting.component.scss
// module id = ./src/app/pages/setting/setting.component.scss
// module chunks = main